export const GET_STATISTIC = 'GET_STATISTIC'
